import {useEffect, useState} from 'react';
import {viewBoxPreviewByBoxNumberHandler} from '../core/infrastructure/projection/boxPreview/viewBoxPreviewByBoxNumber';
import {
  viewBoxPreviewByBoxNumber,
  ViewBoxPreviewByBoxNumberResult,
} from '../core/projection/boxPreview/viewBoxPreviewByBoxNumber';

interface UseViewBoxPreviewByBoxNumberFunctionArgs {
  readonly boxNumber: number | undefined;
}

interface UseViewBoxPreviewByBoxNumberFunction {
  (args: UseViewBoxPreviewByBoxNumberFunctionArgs): ViewBoxPreviewByBoxNumberResult;
}
const useViewBoxPreviewByBoxNumber: UseViewBoxPreviewByBoxNumberFunction = ({boxNumber}) => {
  const [boxPreview, setBoxPreview] = useState<ViewBoxPreviewByBoxNumberResult>(null);

  useEffect(() => {
    const loadBoxPreview = async (): Promise<void> => {
      if (boxNumber) {
        const boxPreview = await viewBoxPreviewByBoxNumberHandler(viewBoxPreviewByBoxNumber({boxNumber}));

        setBoxPreview(boxPreview);
      }
    };

    loadBoxPreview();
  }, [boxNumber]);

  return boxPreview;
};

export {useViewBoxPreviewByBoxNumber};
